module.exports = __webpack_public_path__ + "static/media/AboutfirstWitness.39e329f8.webp";